import { useProductStore } from "~/store/product";

export default defineNuxtRouteMiddleware(async (to, from) => {
  const router = useRouter();
  const { $i18n } = useNuxtApp();
  const localeProperties = $i18n.localeProperties;
  const productStore = useProductStore();

  try {
    if (!productStore.product?.id) {
      const productFromCms = await useFetch(`/api/support/${localeProperties.value.region}/products?language_code=${localeProperties.value.code}`);

      const product = productFromCms.data.value?.find((product) => product.slug === to.params.slug);

      if (!product) {
        throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
      }

      productStore.set(product)
    }
  } catch (error: any) {
    const errorCode = error.response?.data?.errors?.some((err: any) => err.code === 'E_PRODUCT_NOT_FOUND') || error;
    console.info('errorCode ', errorCode);

    if (errorCode) {
      throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
    }
  }
});
